<template>
  <div class="text-center">
    <div>
      <h3>알 수 없는 페이지입니다</h3>
      <router-link
          class="mt-6"
          :to="{ name: registerInformationRouterName }"
      >
        메인 페이지로 이동
      </router-link>
    </div>
  </div>
</template>

<script>
import routerName from "../../constants/routerName";

export default {
  name: "NotFound",
  data: () => ({
    registerInformationRouterName: routerName.REGISTER_INFORMATION
  })
}
</script>

<style scoped>
.text-center {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>